import cssProp from "../../../_js/csssupport";
import _map from "../../../_js/cmp/map";

export default function (widget) {
    const m = widget.m;
    const state = widget.state;

    const ns = widget.ns + '__map';
    const cssTransformProp = cssProp('transform').css; // returns the correct vendor-prefixed CSS property name

    const map = _map(widget);


    const renderDatagridCell = {
        'len,dir': function (ctrl, cellData, cssPos) {
            const rotStyle = cssTransformProp + ':rotate(' + (cellData.direction + 180) + 'deg)';
            return (
                m('div', {
                        className: ns + '__datagrid__cell' +
                        ns + '__datagrid__wind' +
                        // ns+'__datagrid__wind--dir--'+cellData.dirToken +
                        ns + '__datagrid__wind--size--' + cellData.speedToken,
                        style: cssPos,
                    },
                    m('span', {className: ns + '__datagrid__wind__speed'}, cellData.speed),
                    m('span', {className: ns + '__datagrid__wind__arrow', style: rotStyle,})
                )
            );
        },
        _: function (ctrl, cellData, cssPos) {
            return (
                m('div', {
                        className: ns + '__datagrid__cell' + ns + '__datagrid__' + state.forecastType.data,
                        style: cssPos,
                    },
                    cellData
                )
            );
        },
    };


    const renderDatagrid = function (ctrl) {
        if (!state.forecastData) {
            return '';
        }
        const datagrid = state.timepoint.data();
        const gridProps = state.forecastData.datagrid;
        const filter = ctrl.gridFilter;
        if (gridProps && datagrid && datagrid.length && filter) {
            const posGrid = gridProps.positions;
            const cellTemplate = renderDatagridCell[state.forecastType.data.shape] || renderDatagridCell._;
            const cellElms = [];

            const numCols = posGrid.length;
            const numRows = numCols && posGrid[0].length;
            for (let c = filter.cOffs; c < numCols; c += filter.cFactor) {
                for (let r = filter.rOffs; r < numRows; r += filter.rFactor) {
                    const cellPosCss = posGrid[c][r];
                    const cellData = datagrid[c][r];
                    if (cellPosCss != null && cellData != null) {
                        cellElms[cellElms.length] = cellTemplate(ctrl, cellData, cellPosCss);
                    }
                }
            }
            return m('div', {className: ns + '__datagrid'}, cellElms);
        }
        else {
            return '';
        }
    };


    const trellisMap = {

        controller: function (/*props*/) {
            const ctrl = this;

            // ctrl.gridFilter;

            const datagridCellScaling = {
                'len,dir': {/*roundAt: 0.25,*/ scale: 0.83},
                'a,b': {/*roundAt: 0.4, */scale: 0.83},
            };

            const calculateGridFilter = function () {
                const forecastData = state.forecastData;
                if (forecastData && forecastData.datagrid && state.format.is) {
                    const grid = forecastData.datagrid.positions;
                    const cellType = datagridCellScaling[state.forecastType.data] || {};
                    const zoomLevel = state.zoom.level;
                    // maximum number of columns and rows to render
                    const cLim = widget.dataGridWidth *
                        zoomLevel *
                        (cellType.scale || 1) *
                        widget.mediaFormats[state.format.is].scale;
                    const rLim = cLim / state.forecastData.geo.aspect_ratio;

                    // Column and row resolution of the raw datagrid
                    const cRes = grid.length;
                    const rRes = grid[0].length;

                    // Figure out how many raw datagrid colunns and rows to skip when rendering
                    const roundUpPoint = 1 - (cellType.roundAt || 0.5);
                    const cFactor = Math.max(1, Math.floor(cRes / cLim + roundUpPoint));
                    const rFactor = Math.max(1, Math.floor(rRes / rLim + roundUpPoint));

                    // Find the right offset to center the sample used
                    const cOffs = Math.floor((cRes % cFactor || cFactor) / 2);
                    const rOffs = Math.floor((rRes % rFactor || rFactor) / 2);

                    ctrl.gridFilter = {
                        cFactor,
                        rFactor,
                        cOffs,
                        rOffs,
                    };
                }
            };
            calculateGridFilter();

            state.on('format', calculateGridFilter);
            state.on('forecastdata', calculateGridFilter);
            state.on('zoom', calculateGridFilter);
            state.on('forecasttype', calculateGridFilter);


            // const last = {};
            // ctrl.maySkipRendering = function () {
            //   const maySkip = state.forecastData === last.forecastData  &&
            //                 state.forecastType === last.forecastType  &&
            //                 ctrl.isVisible === last.isVisible;
            //   last.forecastData = state.forecastData;
            //   last.forecastType = state.forecastType;
            //   last.isVisible = ctrl.isVisible;
            //   return maySkip;
            // };
        },


        view: function (ctrl, props) {
            // ctrl.props = props || {};

            // if ( ctrl.maySkipRendering() ) {
            //   return  { subtree: 'retain' };
            // }

            return (
                m(map, {
                    className: ns,
                    // id: widget.domid+'__map',
                    underMap: !state.forecastData ? '' :
                              !state.timepoint.plot() ? {subtree: 'retain'} :
                              m('img', {
                                  className: ns + '__plot' + ns + '__plot--' + state.forecastType.plot,
                                  src: state.timepoint.plot(),
                                  alt: ''
                              }),
                    overMap: renderDatagrid(ctrl),
                })
            );

        },


    };


    return trellisMap;
};
